import React from 'react';

import { CircleIcon, CircleIconColorType, IconType } from 'ui/component';
import { StyleUtil } from 'ui/util';
import classNames from './EABD2HomeCard.module.scss';

export interface HomeCardProps
  extends Readonly<{
    icon: IconType;
    iconColor: CircleIconColorType;
    shouldUseIconOutlineStyle: boolean;
    textElementRenderer: () => JSX.Element;
    buttonElementRenderer: () => JSX.Element;
    smallTextElementRenderer?: () => JSX.Element;
    isFrontSide?: boolean;
    style?: React.CSSProperties;
  }> {}

export const HomeCard = React.memo<HomeCardProps>((props) => {
  const {
    icon,
    iconColor,
    shouldUseIconOutlineStyle,
    textElementRenderer,
    buttonElementRenderer,
    smallTextElementRenderer = () => null,
    isFrontSide = true,
    style,
  } = props;

  const IconElement = React.useMemo(() => {
    return (
      <div className={classNames.iconWrapper}>
        <CircleIcon type={icon} color={iconColor} shouldUseOutlineStyle={shouldUseIconOutlineStyle} />
      </div>
    );
  }, [icon, iconColor, shouldUseIconOutlineStyle]);

  const SmallTextElement = React.useMemo(() => {
    return <div className={classNames.smallTextWrapper}>{smallTextElementRenderer()}</div>;
  }, [smallTextElementRenderer]);

  const TextElement = React.useMemo(() => {
    return <div className={classNames.textWrapper}>{textElementRenderer()}</div>;
  }, [textElementRenderer]);

  const ButtonElement = React.useMemo(() => {
    const buttonWrapperClassNames = StyleUtil.createInitialClassNameArray(classNames.buttonWrapper);

    if (isFrontSide) {
      buttonWrapperClassNames.push(classNames.hidden);
    }

    return <div className={StyleUtil.mergeClassNames(buttonWrapperClassNames)}>{buttonElementRenderer()}</div>;
  }, [isFrontSide, buttonElementRenderer]);

  return (
    <div className={classNames.root} style={style}>
      <div className={classNames.header}>
        {SmallTextElement}
        {IconElement}
        {TextElement}
      </div>
      <div className={classNames.footer}>{ButtonElement}</div>
    </div>
  );
});
